import NavBar from './NavBar';
import TopBar from './TopBar';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import AlertProvider from '../../context/alert-context';
import Loader from '../../components/Loader';
import { Hidden } from '@material-ui/core';
import StatisticsComponents from '../../views/Statistics';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden'
  },
  main: {
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_DESKTOP + 20,
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.down('lg')]: {
      paddingTop: APP_BAR_DESKTOP - 20
    }
  }
}));

// ----------------------------------------------------------------------

DashboardLayout.propTypes = {
  children: PropTypes.node
};

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [openNav, setOpenNav] = useState(false);
  const clientId = useSelector((state) => state.globalState.clientID);

  return (
    <AlertProvider>
      <div className={classes.root}>
        {/* <TopBar onOpenNav={() => setOpenNav(true)} /> */}
        <NavBar onCloseNav={() => setOpenNav(false)} isOpenNav={openNav} />
        <div className={classes.main}>
          <Loader />
          {clientId ? (
            <Hidden lgUp>
              <StatisticsComponents clientId={clientId} title="Mobile" />
            </Hidden>
          ) : null}
          {children}
          <TopBar onOpenNav={() => setOpenNav(true)} />
        </div>
      </div>
    </AlertProvider>
  );
}

export default DashboardLayout;
